import * as React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  ariaTitle: PropTypes.string
};

/**
 * Component that renders the Credera logo - Light version with white text
 * Generated using SVGR CLI -> https://react-svgr.com/docs/cli/
 *
 * @component
 * @param {object} props
 */
const SvgCrederaLogoNameLight = props => {
  const { ariaTitle = 'Credera Logo' } = props;

  return (
    <svg role="img" aria-labelledby="credera-logo-name-light-title" width={236} height={40} fill="none" viewBox="0 0 2781.3 450">
      <title id="credera-logo-name-light-title">{ariaTitle}</title>
      <path fill="#fff" d="M722.7 227c0-63 47-109.1 106.1-109.1 36 0 64 15 83 40l-15 11c-16-21-38-33-67-33-49 0-85 39-85 91.1s37 91.1 87 91.1c30 0 55-13 71-35l16 11c-21 28-50 43-88.1 43-60.9-1.1-108-47.1-108-110.1zM1075.9 334h-20V119.9h63c45 0 70 28 70 64 0 29-16 51-45 59l55 90.1h-23l-53-87.1h-47V334zm41.1-105c34 0 50-17 50-45s-16-46-50-46h-41v91h41zM1334.1 119.9h126.1v18h-106.1v79h95.1v18h-95.1v80h111.1v19h-131.1v-214zM1605.2 119.9h53c70 0 111.1 44 111.1 107.1s-41 107.1-111.1 107.1h-53V119.9zm51.1 195.1c62 0 92.1-36 92.1-88.1 0-52-30-88.1-92.1-88.1h-31V315h31zM1909.4 119.9h127.1v18h-107.1v79h96.1v18h-96.1v80h111.1v19h-131.1v-214zM2201.6 334h-20V119.9h63c45 0 70 28 70 64 0 29-16 51-45 59l55 90.1h-23l-53-87.1h-47V334zm41-105c34 0 50-17 50-45s-16-46-50-46h-41v91h41zM2588.8 281h-95.1l-21 53h-20l88.1-218.1h2l89.1 218.1h-21l-22.1-53zm-87-18h80.1l-40-101.1-40.1 101.1z" />
      <path fill="#cfcfcf" d="M327.3 327.3H450V450H327.3z" />
      <path d="M0 0h450v286.4H327.3V122.7H122.7v204.5h163.6V450H0V0z" fill="#e55f4c" />
      <text transform="translate(2676.984 334.032)" fill="#fff" letterSpacing={3} fontSize={30} fontFamily="Lato-Black">
        {'TM'}
      </text>
    </svg>
  );
};

SvgCrederaLogoNameLight.propTypes = propTypes;

export default SvgCrederaLogoNameLight;
